/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartDeliveryOptions',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    'use strict';

    var btns = {
        shipping: '[data-roc-action="Ship"]',
        pickUp: '[data-roc-action="PickUp"]'
    }

    function updateIsShipping(viewModel) {
        var isShipping = true;
        for (var i = 0; i < viewModel.recipients.length; i++) {
            var recipient = viewModel.recipients[i];
            for (var j = 0; j < recipient.items.length; j++) {
                var item = recipient.items[j];
                var deliveryOptions = item.deliveryOptions;
                isShipping = deliveryOptions.selectedDeliveryType === 'Shipping';
            }
        }
        viewModel.isShipping = isShipping;
    }

    function updateDeliveryType(deliveryType) {
        var request = { orderId: '{orderId}', deliveryType: deliveryType };
        Roc.UI.block();
        $.proxyRequest({
            type: 'POST',
            url: '/api/cart/delivery/set',
            data: JSON.stringify(request),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            complete: function (xhr) {
                Roc.UI.unblock();
                var response = xhr.responseJSON;
                if (!response.success) {
                    Roc.UI.displayErrorPopup(response.message);
                }
                Roc.EventManager.notify(Roc.Events.cart.GET_CURRENT_CART, response.cart);
                if (response.cart.multiplePickupLocationsExist && deliveryType === "Pickup") {
                    Roc.UI.displayErrorPopup("Will Call only available out of one location at a time. Please create seperate orders or request a quote.");
                }
            }
        });
    }

    function shippingSelectedEvt() {
        $(document).on('click', btns.shipping, function (e) {
            if ($(btns.shipping).attr('disabled')) {
                return;
            }
            updateDeliveryType('Shipping');
        });
    }

    function pickUpSelectedEvt() {
        $(document).on('click', btns.pickUp, function (e) {
            if ($(btns.pickUp).attr('disabled')) {
                return;
            }
            updateDeliveryType('Pickup');
        });
    }

    function bindEvents() {
        shippingSelectedEvt();
        pickUpSelectedEvt();
    }

    function init() {
        bindEvents();
    };

    var CartDeliveryOptions = {
        init: init,
        updateIsShipping: updateIsShipping
    };

    Roc.Logger.debug('CartDeliveryOptions.js Loaded:', CartDeliveryOptions);

    return CartDeliveryOptions;
});

